import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13b7339c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invest-tabel" }
const _hoisted_2 = { class: "invest-tabel-title" }
const _hoisted_3 = { style: {"color":"red"} }
const _hoisted_4 = { class: "border-card-card-header" }
const _hoisted_5 = { style: {"color":"cornflowerblue"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("-请扫码完成支付 ")
const _hoisted_7 = ["src"]
const _hoisted_8 = { style: {"padding":"14px"} }
const _hoisted_9 = { class: "border-card-bottom" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("已经完成支付")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "您可以用券抵扣费用，请选择券再进行扫码支付：", -1))
const _hoisted_13 = { style: {"color":"red"} }

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import Bottom from './components/bottom.vue'
import { MoreFilled } from '@element-plus/icons-vue'

import tool from "@/utils/tool";
import router from "@/router/index";
import { Plus } from '@element-plus/icons-vue';

interface Coupon {
  id: string;
  availableAmount: number;
  couponBatchId: string;
  isMultiAddUse: string;
}

type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const radio1 = ref('1')
const active = 1;
const activitiesStep = [
  {
    content: '报名',
    timestamp: '2018-04-12 20:46',
    size: 'large',
    type: 'primary',
    icon: MoreFilled,
  },
  {
    content: '缴费',
    timestamp: '2018-04-03 20:46',
    color: '#0bbd87',
    type: 'primary',
  },
  {
    content: '成功',
    timestamp: '2018-04-03 20:46',
    size: 'large',
  },
];

const isDisabled = ref(false);
const couponUseMax = ref(2);

var id = router.currentRoute.value.params.id;
if (typeof id == "string") {
  store.dispatch("frontTrainingModule/getActivityApply", { activityId: id }).then(
    (data) => {
      //成功
      if (data.result != null) {
        bindData.activityApply = data.result;
        bindData.paymentForm.paymentAmount = bindData.activityApply.cost;
        bindData.paymentForm.cashPaymentAmount = bindData.activityApply.cost;
        isDisabled.value = true;
        switch (bindData.activityApply.type) {
          case 1:
            bindData.title = "楼盘招商报名支付";
            break;
          case 2:
            bindData.title = "社区营销报名支付";
            break;
          case 3:
            bindData.title = "经销商招募报名支付";
            break;
          case 4:
            bindData.title = "拎包培训报名支付";
            break;
          case 5:
            bindData.title = "行业会议报名支付";
            break;
          case 6:
            bindData.title = "私享会报名支付";
            break;
          case 7:
            bindData.title = "拎包商加盟报名支付";
            break;
          default:
            bindData.title = "";
            break;
        }
      }
    },
    (error) => {
      console.log(error.msg);
    }
  );
}

const paymentFormRef = ref<FormInstance>();
const couponUseIdArray = ref([''])
const bindData = reactive({
  title: '',
  isShowCoupons: false,
  coupons: new Array<Coupon>(),
  couponIds: '',
  loginMember: {
    balance: 0,
  },
  isShowQrcode: false,
  qrcodeUrl: '',
  paymentType: 0,
  paymentTypeName: '',
  paymentForm: {
    paymentAmount: 0.00,
    cashPaymentAmount: 0.00,
  },
  memberName: '',
  activityApply: {
    id: '',
    code: '',
    activityId: '',
    contact: '',
    mobile: '',
    cost: 0.00,
    type: 0,
  }
});

const ustore = useStore();

if (typeof id == "string") {
  bindData.activityApply.activityId = id;
}

bindData.memberName = ustore.state.loginMember == undefined ? '' : ustore.state.loginMember.companyName

const loadData = () => {
  store.dispatch("getMyInfo").then(
    (data) => {
      //成功
      bindData.memberName = data.result.companyName;
    },
    (error) => {
      ElMessageBox.alert(error.msg, "系统消息", {
        confirmButtonText: "关闭",
        callback: (action: Action) => { },
      });
    }
  );
};

const listCoupons = () => {
  store
    .dispatch("frontIndexModule/listCanUseCoupons", { objectTypeCode: 1, objectId: bindData.activityApply.activityId })
    .then(
      (data) => {
        bindData.coupons = data.result;
        bindData.isShowCoupons = data.totalCount > 0;
        var isMultiAddUse = false;
        for (let index in bindData.coupons) {
          var coupon = bindData.coupons[index];
          if(coupon.isMultiAddUse=='Y') {
            isMultiAddUse = true;
          }
        }
        console.log(isMultiAddUse)
        if(isMultiAddUse) {
          couponUseMax.value = 100;
        }
      },
      (error) => {
        console.log(error.msg);
      }
    );
}

if (ustore.state.loginMember == undefined) {
  loadData();
}


const chooseTaobaoPaymentEvent = () => {
  bindData.isShowQrcode = true;
  bindData.paymentType = 1;
  bindData.paymentTypeName = "支付宝";
}

const chooseWeixinPaymentEvent = () => {
  bindData.isShowQrcode = true;
  bindData.paymentType = 2;
  bindData.paymentTypeName = "微信";

  if (bindData.paymentForm.paymentAmount == null || bindData.paymentForm.paymentAmount < 0.01) {
    ElMessage.error("最低支付50.");
    return;
  }
  store
    .dispatch("frontIndexModule/createWxPayOrder", { payType: 1, orderNum: bindData.activityApply.code, amount: bindData.activityApply.cost, mobile: bindData.activityApply.mobile, couponIds: bindData.couponIds })
    .then(
      (data) => {
        ElMessage.success("微信支付二维码生成成功！");
        bindData.qrcodeUrl = tool.url("/weixinApi/getQrCode?qrcodeKey=" + data.qrcodeKey);
      },
      (error) => {
        console.log(error.msg);
        ElMessage.error(error.msg);
      }
    );

}


const handleToChooseCoupons = () => {
  const couponIds = new Array<string>();
  var paymentAmount = 0.00;
  var i = 0;
  for (let index in bindData.coupons) {
    var coupon = bindData.coupons[index];
    if (couponUseIdArray.value.includes(coupon.id) && paymentAmount < bindData.paymentForm.paymentAmount) {
      paymentAmount += coupon.availableAmount;
      couponIds[i] = coupon.id;
      i++;
    }
  }
  paymentAmount = (bindData.paymentForm.paymentAmount - paymentAmount);
  if (paymentAmount < 0.01) {
    paymentAmount = 0.01;
  }
  bindData.paymentForm.cashPaymentAmount = paymentAmount;
  bindData.couponIds = couponIds.join(",");

  if (bindData.paymentType == 1) {
    chooseTaobaoPaymentEvent();
  }
  else {
    chooseWeixinPaymentEvent();
  }
}

const paymentOkEvent = () => {
  bindData.isShowQrcode = false;
  store.dispatch("frontTrainingModule/getActivityApply", { activityId: id }).then(
    (data) => {
      //成功
      if (data.result != null) {
        var activityApply = data.result;
        if(activityApply.isPayed=="Y") {
          router.push("/frontDesk/applySuccess/" + activityApply.activityId);
        }
      }
    },
    (error) => {
      console.log(error.msg);
    }
  );
  
}

listCoupons();



return (_ctx: any,_cache: any) => {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(bindData).title), 1),
      _createVNode(_component_el_steps, {
        active: active,
        "finish-status": "success"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(activitiesStep, (activityStep, index) => {
            return _createVNode(_component_el_step, {
              key: index,
              title: activityStep.content
            }, null, 8, ["title"])
          }), 64))
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                model: _unref(bindData).paymentForm,
                ref_key: "paymentFormRef",
                ref: paymentFormRef,
                "label-width": "120px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "姓名" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_unref(bindData).activityApply.contact), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "电话" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_unref(bindData).activityApply.mobile), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "请支付报名费",
                    pop: "paymentAmount"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, "¥ " + _toDisplayString(_unref(bindData).paymentForm.cashPaymentAmount.toFixed(2)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "支付方式" }, {
                    default: _withCtx(() => [
                      (_unref(bindData).paymentType == 1)
                        ? (_openBlock(), _createBlock(_component_el_image, {
                            key: 0,
                            class: "el-button el-button--danger el-button--default border-card-btn-payment border-card-btn-active",
                            src: require('@/assets/u11080.png'),
                            onClick: chooseTaobaoPaymentEvent
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createBlock(_component_el_image, {
                            key: 1,
                            class: "el-button el-button--danger el-button--default border-card-btn-payment",
                            src: require('@/assets/u11080.png'),
                            onClick: chooseTaobaoPaymentEvent
                          }, null, 8, ["src"])),
                      (_unref(bindData).paymentType == 2)
                        ? (_openBlock(), _createBlock(_component_el_image, {
                            key: 2,
                            class: "el-button el-button--danger el-button--default border-card-btn-payment border-card-btn-active",
                            src: require('@/assets/u11085.png'),
                            onClick: chooseWeixinPaymentEvent
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createBlock(_component_el_image, {
                            key: 3,
                            class: "el-button el-button--danger el-button--default border-card-btn-payment",
                            src: require('@/assets/u11085.png'),
                            onClick: chooseWeixinPaymentEvent
                          }, null, 8, ["src"]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              (_unref(bindData).isShowQrcode)
                ? (_openBlock(), _createBlock(_component_el_container, {
                    key: 0,
                    class: "border-card-btn"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, { "body-style": { padding: '0px' } }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(bindData).paymentTypeName), 1),
                            _hoisted_6
                          ]),
                          _createElementVNode("img", {
                            src: _unref(bindData).qrcodeUrl,
                            class: "border-card-image"
                          }, null, 8, _hoisted_7),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_unref(ElButton), {
                                type: "primary",
                                size: "large",
                                onClick: paymentOkEvent
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_10
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              (_unref(bindData).isShowCoupons)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox_group, {
                          modelValue: couponUseIdArray.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((couponUseIdArray).value = $event)),
                          max: couponUseMax.value,
                          onChange: handleToChooseCoupons
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 8 }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).coupons, (coupon) => {
                                  return (_openBlock(), _createBlock(_component_el_checkbox, {
                                    key: coupon.id,
                                    label: coupon.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(coupon.name + " 券号: " + coupon.couponNo + " 有效期: " + coupon.gmtActive + '~' + coupon.gmtExpired) + " 面额: ", 1),
                                      _createElementVNode("span", _hoisted_13, "¥" + _toDisplayString(coupon.availableAmount), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "max"])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, { class: "invest-tabel-btn" })
    ]),
    _createVNode(Bottom)
  ]))
}
}

})